import PropTypes from 'prop-types';

import {pushInteractionTagManager} from '../../services/tagManager';
import './AccreditationLink.style.scss';

export const AccreditationLink = (props) => {
  const openAccreditationModal = () => {
    pushInteractionTagManager({
      screenName: 'credenciamento:home',
      elementType: props.elementType,
      elementContent: props.elementContent
    });
    props.buttonFunctionShowAccreditation();
  };

  return (
    <button
      type="button"
      id="question-link"
      data-testid="question-link"
      className="question question__link"
      onClick={() => openAccreditationModal()}
    >
      {props.children}
    </button>
  );
};

AccreditationLink.propTypes = {
  buttonFunctionShowAccreditation: PropTypes.func,
  elementType: PropTypes.string,
  elementContent: PropTypes.string,
  children: PropTypes.string
};
